import { Component, OnChanges, Input, SimpleChanges, Output, EventEmitter, AfterViewInit, ViewChild, OnInit } from '@angular/core';
import { FlattenObjectPipe } from '@app/pipes/flatten-object.pipe';
import { DataTableDirective } from 'angular-datatables';
import * as _ from 'lodash';
import type { Api } from 'datatables.net';
@Component({
    selector: 'mrp-table',
    templateUrl: './mrp-table.component.html',
    styleUrls: ['./mrp-table.component.scss'],
    standalone: false
})
export class MrpTableComponent implements OnChanges, AfterViewInit, OnInit {
    @ViewChild(DataTableDirective)
    datatableElement: DataTableDirective;
    @Input() columns: any[] = [];
    @Input() data: any[] = [];
    @Input() config: any = {};

    @Output() selectionRow = new EventEmitter<string>();
    dtOptions: any = {};
    // datatableElement: DataTableDirective;

    constructor() {

     }

    ngOnChanges(changes: SimpleChanges) {
        this.dtOptions = {
            columns: this.columns,
            bInfo: false,
            language: {
                "decimal": "",
                "emptyTable": "",
                "info": "Showing _START_ to _END_ of _TOTAL_ entries",
                "infoEmpty": "Showing 0 to 0 of 0 entries",
                "infoFiltered": "(filtered from _MAX_ total entries)",
                "infoPostFix": "",
                "thousands": ",",
                "lengthMenu": "Mostrar _MENU_",
                "loadingRecords": "Loading...",
                "processing": "Processing...",
                "search": "Buscar:",
                "zeroRecords": "",
                "paginate": {
                    "first": "First",
                    "last": "Last",
                    "next": "Siguiente",
                    "previous": "Atras"
                },
                "aria": {
                    "sortAscending": ": activate to sort column ascending",
                    "sortDescending": ": activate to sort column descending"
                }
            }
        }
    }

    ngOnInit(): void{
        console.log('data', this.data);
    }

    ngAfterViewInit(): void {
        
        this.datatableElement.dtInstance.then((dtInstance: Api) => {
            dtInstance.columns().every(function() {
                const that = this;
                $('input', this.footer()).on('keyup change', function() {
                    if (that.search() !== this['value']) {
                        that
                            .search(this['value'])
                            .draw();
                    }
                });
            });
        });
    }
    onClickRow(item) {
        console.log({item})
        this.selectionRow.emit(item);
    }

}
